/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

function SearchBarInput(props) {
    const {
        name, type, value, className, onChange, required,
        onKeyUp, onKeyDown, onKeyPress, onFocus, onBlur,
        icon, reference, readOnly, disabled, onClick, intl,
    } = props;

    let { iconPosition } = props;
    const allowedIconPosition = [ 'left', 'right' ];
    iconPosition = allowedIconPosition.some(validBorder => validBorder === iconPosition) ? ` icon-position-${iconPosition}` : '';
    const placeholder = intl.formatMessage({ id: 'bf.locationOrHotelName', defaultMessage: 'bf.locationOrHotelName' });

    return (
        <div className="kbe-search-bar-input-main-wrapper">
            <div className={`kbe-search-bar-input-wrapper${iconPosition}`}>
                {icon ? <i className={`bf-icon-${icon} kbe-search-bar-input-icon`} /> : null}
                <input
                    placeholder={placeholder}
                    type={type}
                    value={value}
                    name={name}
                    ref={reference}
                    onChange={onChange}
                    className={`kbe-search-bar-input ${className}`}
                    onKeyUp={onKeyUp}
                    onKeyDown={onKeyDown}
                    onKeyPress={onKeyPress}
                    onClick={onClick}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    required={required}
                    readOnly={readOnly}
                    disabled={disabled}
                />
            </div>
        </div>
    );
}

SearchBarInput.defaultProps = {
    className    : '',
    name         : '',
    onBlur       : null,
    onChange     : null,
    onFocus      : null,
    onKeyDown    : null,
    onKeyPress   : null,
    onKeyUp      : null,
    required     : false,
    type         : 'text',
    value        : '',
    icon         : '',
    iconPosition : '',
    readOnly     : false,
    disabled     : false,
    reference    : null,
    onClick      : () => {},
};

SearchBarInput.propTypes = {
    className    : PropTypes.string,
    name         : PropTypes.string,
    onBlur       : PropTypes.func,
    onChange     : PropTypes.func,
    onFocus      : PropTypes.func,
    onKeyDown    : PropTypes.func,
    onKeyPress   : PropTypes.func,
    onClick      : PropTypes.func,
    onKeyUp      : PropTypes.func,
    required     : PropTypes.bool,
    type         : PropTypes.string,
    value        : PropTypes.string,
    icon         : PropTypes.string,
    iconPosition : PropTypes.string,
    readOnly     : PropTypes.bool,
    disabled     : PropTypes.bool,
    reference    : PropTypes.shape({}),
    intl         : PropTypes.shape(intlShape).isRequired,
};

export default injectIntl(SearchBarInput);
